import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StaticCalendar } from './staticCalendar';

const routes: Routes = [
  {
    path: 'achievements',
    component: StaticCalendar,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaticCalendarRoutingModule {}
